const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const mapOptions = {
  googleMapAPiKey: GOOGLE_MAPS_API_KEY
}

export const seccionalesPines = [
  {
    nombre: "UATRE - Chaco - Villa Berthet",
    loc:{
      lat: -27.2880154,
      lng: -60.4114569
    }
  },
  {
    nombre: "UATRE - Chaco - Villa Berthet",
    loc:{
      lat: -27.5285408,
      lng: -59.584653
    }
  },
  {
    nombre: "UATRE - Chaco - Cote Lai",
    loc:{
      lat: -27.5285408,
      lng: -59.584653
    }
  },
  {
    nombre: "UATRE - Chaco - Las Breñas",
    loc:{
      lat: -27.0907605,
      lng: -61.0912394
    }
  },
  {
    nombre: "UATRE - Chaco - Campo Largo",
    loc:{
      lat: -26.8005075,
      lng: -60.8403066
    }
  },
  {
    nombre: "UATRE - Chaco - Concepcion del Bermejo",
    loc:{
      lat: -26.5996299,
      lng: -60.9463686
    }
  },
  {
    nombre: "UATRE - Chaco - Tres Isletas",
    loc:{
      lat: -26.3418542,
      lng: -60.4705798
    }
  },
  {
    nombre: "UATRE - Chaco - Los Frentones",
    loc:{
      lat: -26.4094675,
      lng: -61.4189114
    }
  },
  {
    nombre: "UATRE - Chaco - San bernardo",
    loc:{
      lat: -27.2867055,
      lng: -60.7181368
    }
  },
  {
    nombre: "UATRE - Chaco - Corzuela",
    loc:{
      lat: -26.957897, 
      lng: -60.966787
    }
  },
  {
    nombre: "UATRE - Chaco - Resistencia",
    loc:{
      lat: -27.4606474,
      lng: -58.9844964
    }
  },
  {
    nombre: "UATRE - Chaco - Coronel Du Graty",
    loc:{
      lat: -27.6856791,
      lng: -60.9128627
    }
  },
  {
    nombre: "UATRE - Chaco - Quitilipi",
    loc:{
      lat: -26.8837276,
      lng: -60.2146811
    }
  },
  {
    nombre: "UATRE - Chaco - General Pinedo",
    loc:{
      lat: -27.3248982,
      lng: -61.2876371
    }
  },
  {
    nombre: "UATRE - Chaco - Hermoso Campo",
    loc:{
      lat: -27.6120851,
      lng: -61.3435611
    }
  },
  {
    nombre: "UATRE - Chaco - Machagai",
    loc:{
      lat: -26.9256837,
      lng: -60.0491963
    }
  },
  {
    nombre: "UATRE - Chaco - Pampa del Infierno",
    loc:{
      lat: -26.5065416,
      lng: -61.177045
    }
  },
//-----------BS AS
  {
    nombre: "UATRE - BS AS - CHIVILCOY",
    loc:{
      lat: -34.8985584,
      lng: -60.0215719
    }
  },
  {
    nombre: "UATRE - BS AS - PINZON",
    loc:{
      lat: -33.995195,
      lng: -60.7329388
    }
  },
  {
    nombre: "UATRE - BS AS - ASCENSION",
    loc:{
      lat: -34.2342638,
      lng: -61.1071743
    }
  },
  {
    nombre: "UATRE - BS AS - ARRIBEÑOS",
    loc:{
      lat: -34.2125732,
      lng: -61.360471
    }
  },

  {
    nombre: "UATRE - BS AS - CAPITAN SARMIENTO",
    loc:{
      lat: -34.1713636,
      lng: -59.7894058
    }
  },
  {
    nombre: "UATRE - BS AS - FERRE",
    loc:{
      lat: -34.1210171,
      lng: -61.1357542
    }
  },
  
  {
    nombre: "UATRE - BS AS - EL SOCORRO",
    loc:{
      lat: -33.661824,
      lng: -60.7088398
    }
  },

  {
    nombre: "UATRE - BS AS - RIO TALA",
    loc:{
      lat: -33.7655653,
      lng: -59.6368739
    }
  },
]

export const delegacionesPines = [
  
  {
    nombre: "UATRE - SEDE CENTRAL CIUDAD AUTÓNOMA DE BUENOS AIRES Reconquista 630",
    loc:{
      lat: -34.60044,
      lng: -58.37285
    }
  },
  {
    nombre: "UATRE - BUENOS AIRES ZONA NORTE Florida 1021 (CP 2700)",
    loc:{
      lat: -33.89526,
      lng: -60.5814649
    }
  },
  {
    nombre: "UATRE - BUENOS AIRES - BAHÍA BLANCA Lavalle 570 (CP 7540)",
    loc:{
      lat: -38.71573,
      lng: -62.2574649
    }
  },
  {
    nombre: "UATRE - BUENOS AIRES - GRAN BUENOS AIRES Av. Independencia 3058 (CP 1225)",
    loc:{
      lat: -34.61989,
      lng: -58.4111649
    }
  },
]